import { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';
import css from './footbar.module.css';

type FootbarProps = {
  buttonRight: ReactNode;
  buttonLeft: ReactNode;
  elevated?: boolean;
  style?: CSSProperties;
};

export function Footbar({
  buttonLeft,
  buttonRight,
  elevated = false,
  style,
}: FootbarProps): JSX.Element {
  return (
    <div
      className={clsx(
        'border-gray fixed bottom-0 z-40 w-full border-0 border-t border-solid bg-white/60 backdrop-blur-md xl:hidden',
        { 'z-50': elevated },
        css.container,
      )}
      style={style}
    >
      <div className="container flex h-full items-center justify-between">
        {buttonLeft}
        {buttonRight}
      </div>
    </div>
  );
}
